'use strict';

/**
 * DrawToolFactory
 * @description Initializes a new `drawTool` for a specific map
 */

var _ = require('lodash');
var DrawCircle = require('./handlers/DrawCircle');
var DrawMarker = require('./handlers/DrawMarker');
var DrawPolygon = require('./handlers/DrawPolygon');
var DrawPolyline = require('./handlers/DrawPolyline');
var DrawRectangle = require('./handlers/DrawRectangle');
var DrawText = require('./handlers/DrawText');
var LayerStyles = require('./lib/LayerStyles');

var DrawFactory = function ($q, MapStrings) {
  
  function Draw (map, Actions, Store) {
    _.defaults(this, {
      map: map,
      _activeHandler: null,
      _activeDeferred: null,
      Actions: Actions,
      Store: Store
    });
  }

  Draw.prototype = {

    draw: function (type, options) {
      
      // cancel existing draw
      this.cancel();
    
      var handler;
      var map = this.map;
      var deferred = $q.defer();
      var promise = deferred.promise;

      options = this._extendOptions(type, options);
      handler = this.newHandler(type, options);
      
      // start the drawing
      handler.enable();

      map.once('draw:created', function (e) {
        var leafletLayer = e.layer;
        deferred.resolve(leafletLayer);

        // cleanup
        if (this._activeHandler) {
          this._activeHandler.disable();
        }
        
        this._activeHandler = null;
        this._activeDeferred = null;

      }.bind(this));

      map.once('draw:drawcancel', function (e) {
        this.cancel();
      }.bind(this));

      this._activeHandler = handler;
      this._activeDeferred = deferred;
      return promise;
    },

    cancel: function () {
      if (this._activeHandler && this._activeDeferred) {
        this._activeHandler.disable();
        this._activeDeferred.reject('draw:drawcancel');
        this._activeHandler = null;
        this._activeDeferred = null;
      }
    },

    newHandler: function (type, options) {
      
      var Actions = this.Actions;
      var Store = this.Store;
      var map = this.map;

      var handlers = {
        circle: function () {
          return new DrawCircle(map, options, Actions, Store);
        },
        marker: function () {
          return new DrawMarker(map, options, Actions, Store);
        },
        polygon: function () {
          return new DrawPolygon(map, options, Actions, Store);
        },
        polyline: function () {
          return new DrawPolyline(map, options, Actions, Store);
        },
        rectangle: function () {
          return new DrawRectangle(map, options, Actions, Store);
        },
        text: function () {
          return new DrawText(map, options, Actions, Store);
        }
      };

      var getter = handlers[type];

      if (!getter) {
        throw new Error('Unknown draw handler: ' + type);
      }

      return getter();
    },

    _extendOptions: function (type, options) {
      var styles = LayerStyles[type];
      
      options = _.extend({
        styles: styles
      }, options);

      if (options.strings) {
        this._setHandlerStrings(type, options.strings);
      }

      // add the custom draw strings
      options.strings = _.extend({}, MapStrings.Strings.draw, options.strings);

      return options;
    },

    /**
     * Set the display text of the draw handler.
     *
     * @see https://github.com/Leaflet/Leaflet.draw/blob/master/src/Leaflet.draw.js
     * 
     * @param {String} type Draw type
     * @param {Object} strings
     * @param {String} [strings.start]
     * @param {String} [strings.cont]
     * @param {String} [strings.error]
     * @param {String} [strings.end]
     */
    _setHandlerStrings: function (type, strings) {

      var tooltipStrings = strings.tooltip;
      var errorStrings = strings.errors;

      if (type === 'text') {
        type = 'marker';
      }

      
      // Allow the application to override the leaflet draw strings
      _.forEach(tooltipStrings, function (string, stype) {
        L.drawLocal.draw.handlers[type].tooltip[stype] = string;
      });

      // Set default error if available
      if (errorStrings && errorStrings.default) {
        L.drawLocal.draw.handlers[type].tooltip.error = errorStrings.default;
      }
    }
  };

  return {
    create: function (map, Actions, Store) {
      return new Draw(map, Actions, Store);
    }
  };
};

DrawFactory.$inject = ['$q', 'sbMapStrings'];
module.exports = DrawFactory;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/draw/Draw.js